<template>
  <div>
    <div class="nav">
      <div class="main">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>立体教材</el-breadcrumb-item>
          <el-breadcrumb-item>立体教材详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="main">
      <div class="centest">
        <div class="testTit">第一章节：章节名称</div>
        <div class="testTip">
          本章通过单选、多选题、判断、填空和简答题对学习效果进行测试，共10分，其中单选题1道，每道题2分，多选题1道，每道题3分，
          判断题1道，每道题2分，简答题1道，每道题3分。注意截止提交时间为2018年12月21日23：00.
        </div>

        <div>
          <div v-if="singlesshow == true">
            <div v-for="(item, index) in single" :key="index">
              <div class="Tit" v-html="item.examTitle"></div>
              <!-- 题目图片显示 -->
              <div v-if="item.titleImage" class="title-image">
                <img :src="item.titleImage" alt="题目图片" class="exam-image" />
              </div>
              <el-radio-group v-model="ruleForm.single">
                <el-radio label="A">
                  <span v-if="item.optionType == 1 && isImageUrl(item.optiona)">
                    A、<img :src="extractImageUrl(item.optiona)" alt="选项A" class="option-image" />
                  </span>
                  <span v-else>{{ item.optiona }}</span>
                </el-radio>
                <el-radio label="B">
                  <span v-if="item.optionType == 1 && isImageUrl(item.optionb)">
                    B、<img :src="extractImageUrl(item.optionb)" alt="选项B" class="option-image" />
                  </span>
                  <span v-else>{{ item.optionb }}</span>
                </el-radio>
                <el-radio label="C">
                  <span v-if="item.optionType == 1 && isImageUrl(item.optionc)">
                    C、<img :src="extractImageUrl(item.optionc)" alt="选项C" class="option-image" />
                  </span>
                  <span v-else>{{ item.optionc }}</span>
                </el-radio>
                <el-radio label="D">
                  <span v-if="item.optionType == 1 && isImageUrl(item.optiond)">
                    D、<img :src="extractImageUrl(item.optiond)" alt="选项D" class="option-image" />
                  </span>
                  <span v-else>{{ item.optiond }}</span>
                </el-radio>
              </el-radio-group>
              <div
                class="send"
                v-if="!send"
                @click="getTestItem(item.fid, ruleForm.single)"
              >
                下一题
              </div>
            </div>
          </div>
        </div>
        <div v-if="multipleshow == true">
          <div v-for="(item, index) in multiple" :key="index">
            <div class="Tit" v-html="item.examTitle"></div>
            <!-- 题目图片显示 -->
            <div v-if="item.titleImage" class="title-image">
              <img :src="item.titleImage" alt="题目图片" class="exam-image" />
            </div>
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox label="A" name="type">
                <span v-if="item.optionType == 1 && isImageUrl(item.optiona)">
                  A、<img :src="extractImageUrl(item.optiona)" alt="选项A" class="option-image" />
                </span>
                <span v-else>{{ item.optiona }}</span>
              </el-checkbox>
              <el-checkbox label="B" name="type">
                <span v-if="item.optionType == 1 && isImageUrl(item.optionb)">
                  B、<img :src="extractImageUrl(item.optionb)" alt="选项B" class="option-image" />
                </span>
                <span v-else>{{ item.optionb }}</span>
              </el-checkbox>
              <el-checkbox label="C" name="type">
                <span v-if="item.optionType == 1 && isImageUrl(item.optionc)">
                  C、<img :src="extractImageUrl(item.optionc)" alt="选项C" class="option-image" />
                </span>
                <span v-else>{{ item.optionc }}</span>
              </el-checkbox>
              <el-checkbox label="D" name="type">
                <span v-if="item.optionType == 1 && isImageUrl(item.optiond)">
                  D、<img :src="extractImageUrl(item.optiond)" alt="选项D" class="option-image" />
                </span>
                <span v-else>{{ item.optiond }}</span>
              </el-checkbox>
              <el-checkbox label="E" name="type" v-if="item.optione !== null">
                <span v-if="item.optionType == 1 && isImageUrl(item.optione)">
                  E、<img :src="extractImageUrl(item.optione)" alt="选项E" class="option-image" />
                </span>
                <span v-else>{{ item.optione }}</span>
              </el-checkbox>
            </el-checkbox-group>
            <div
              class="send"
              v-if="!send"
              @click="getTestItem(item.fid, ruleForm.type)"
            >
              下一题
            </div>
          </div>
        </div>
        <div v-if="judgeshow == true">
          <div v-for="(item, index) in judge" :key="index">
            <div class="Tit" v-html="item.examTitle"></div>
            <!-- 题目图片显示 -->
            <div v-if="item.titleImage" class="title-image">
              <img :src="item.titleImage" alt="题目图片" class="exam-image" />
            </div>
            <el-radio-group label v-model="ruleForm.judge">
              <el-radio label="A">
                <!-- {{item.optiona}} -->
                <span class="icoText">A.</span>
                <!-- <i class="el-icon-check icoLogo"></i> -->
                <img src="../../assets/img/right.png" alt class="icoLogo" />
              </el-radio>
              <el-radio label="B">
                <!-- {{item.optionb}} -->
                <span class="icoText">B.</span>
                <!-- <i class="el-icon-close"></i> -->
                <img src="../../assets/img/false.png" alt class="icoLogo" />
              </el-radio>
            </el-radio-group>
            <div
              class="send"
              v-if="!send"
              @click="getTestItem(item.fid, ruleForm.judge)"
            >
              下一题
            </div>
          </div>
        </div>
        <div v-if="blanksshow == true">
          <div v-for="(item, index) in blanks" :key="index">
            <div class="Tit" v-html="item.examTitle"></div>
            <!-- 题目图片显示 -->
            <div v-if="item.titleImage" class="title-image">
              <img :src="item.titleImage" alt="题目图片" class="exam-image" />
            </div>
            <el-input
              v-model="ruleForm.blanks"
              placeholder="请输入正确答案"
            ></el-input>
            <div
              class="send"
              v-if="!send"
              @click="getTestItem(item.fid, ruleForm.blanks)"
            >
              下一题
            </div>
          </div>
        </div>
        <div v-if="shortshow == true">
          <div v-for="(item, index) in short" :key="index">
            <div class="Tit" v-html="item.examTitle"></div>
            <!-- 题目图片显示 -->
            <div v-if="item.titleImage" class="title-image">
              <img :src="item.titleImage" alt="题目图片" class="exam-image" />
            </div>
            <el-input
              type="textarea"
              v-model="ruleForm.short"
              placeholder="请输入正确答案"
            ></el-input>
            <div
              class="send"
              v-if="!send"
              @click="getTestItem(item.fid, ruleForm.short)"
            >
              下一题
            </div>
          </div>
        </div>
        <!-- 综合题展示 -->
        <div v-if="comprehensiveshow == true">
          <div v-for="(comprehensiveItem, comprehensiveIndex) in comprehensive" :key="comprehensiveIndex">
            <div class="Tit" v-html="comprehensiveItem.examTitle"></div>
            <!-- 遍历综合题中的子题目 -->
            <div v-for="(subItem, subIndex) in comprehensiveItem.examList" :key="subIndex" class="sub-question">
              <div class="Tit" v-html="subItem.examTitle"></div>
              <!-- 子题目图片显示 -->
              <div v-if="subItem.titleImage" class="title-image">
                <img :src="subItem.titleImage" alt="题目图片" class="exam-image" />
              </div>
              <!-- 单选题 -->
              <div v-if="subItem.examType == 0">
                <el-radio-group v-model="comprehensiveAnswers[subItem.fid]">
                  <el-radio label="A">
                    <span v-if="subItem.optionType == 1 && isImageUrl(subItem.optiona)">
                      A、<img :src="extractImageUrl(subItem.optiona)" alt="选项A" class="option-image" />
                    </span>
                    <span v-else>{{ subItem.optiona }}</span>
                  </el-radio>
                  <el-radio label="B">
                    <span v-if="subItem.optionType == 1 && isImageUrl(subItem.optionb)">
                      B、<img :src="extractImageUrl(subItem.optionb)" alt="选项B" class="option-image" />
                    </span>
                    <span v-else>{{ subItem.optionb }}</span>
                  </el-radio>
                  <el-radio label="C">
                    <span v-if="subItem.optionType == 1 && isImageUrl(subItem.optionc)">
                      C、<img :src="extractImageUrl(subItem.optionc)" alt="选项C" class="option-image" />
                    </span>
                    <span v-else>{{ subItem.optionc }}</span>
                  </el-radio>
                  <el-radio label="D">
                    <span v-if="subItem.optionType == 1 && isImageUrl(subItem.optiond)">
                      D、<img :src="extractImageUrl(subItem.optiond)" alt="选项D" class="option-image" />
                    </span>
                    <span v-else>{{ subItem.optiond }}</span>
                  </el-radio>
                </el-radio-group>
              </div>
              <!-- 多选题 -->
              <div v-if="subItem.examType == 1">
                <el-checkbox-group v-model="comprehensiveAnswers[subItem.fid]">
                  <el-checkbox label="A" name="type">
                    <span v-if="subItem.optionType == 1 && isImageUrl(subItem.optiona)">
                      A、<img :src="extractImageUrl(subItem.optiona)" alt="选项A" class="option-image" />
                    </span>
                    <span v-else>{{ subItem.optiona }}</span>
                  </el-checkbox>
                  <el-checkbox label="B" name="type">
                    <span v-if="subItem.optionType == 1 && isImageUrl(subItem.optionb)">
                      B、<img :src="extractImageUrl(subItem.optionb)" alt="选项B" class="option-image" />
                    </span>
                    <span v-else>{{ subItem.optionb }}</span>
                  </el-checkbox>
                  <el-checkbox label="C" name="type">
                    <span v-if="subItem.optionType == 1 && isImageUrl(subItem.optionc)">
                      C、<img :src="extractImageUrl(subItem.optionc)" alt="选项C" class="option-image" />
                    </span>
                    <span v-else>{{ subItem.optionc }}</span>
                  </el-checkbox>
                  <el-checkbox label="D" name="type">
                    <span v-if="subItem.optionType == 1 && isImageUrl(subItem.optiond)">
                      D、<img :src="extractImageUrl(subItem.optiond)" alt="选项D" class="option-image" />
                    </span>
                    <span v-else>{{ subItem.optiond }}</span>
                  </el-checkbox>
                  <el-checkbox label="E" name="type" v-if="subItem.optione !== null">
                    <span v-if="subItem.optionType == 1 && isImageUrl(subItem.optione)">
                      E、<img :src="extractImageUrl(subItem.optione)" alt="选项E" class="option-image" />
                    </span>
                    <span v-else>{{ subItem.optione }}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <!-- 判断题 -->
              <div v-if="subItem.examType == 2">
                <el-radio-group v-model="comprehensiveAnswers[subItem.fid]">
                  <el-radio label="A">
                    <span class="icoText">A.</span>
                    <img src="../../assets/img/right.png" alt class="icoLogo" />
                  </el-radio>
                  <el-radio label="B">
                    <span class="icoText">B.</span>
                    <img src="../../assets/img/false.png" alt class="icoLogo" />
                  </el-radio>
                </el-radio-group>
              </div>
              <!-- 填空题 -->
              <div v-if="subItem.examType == 3">
                <el-input
                  v-model="comprehensiveAnswers[subItem.fid]"
                  placeholder="请输入正确答案"
                ></el-input>
              </div>
              <!-- 简答题 -->
              <div v-if="subItem.examType == 4">
                <el-input
                  type="textarea"
                  v-model="comprehensiveAnswers[subItem.fid]"
                  placeholder="请输入正确答案"
                ></el-input>
              </div>
            </div>
            <div
              class="send"
              v-if="!send"
              @click="getTestItem(comprehensiveItem.fid, getComprehensiveAnswers(comprehensiveItem))"
            >
              下一题
            </div>
          </div>
        </div>
        <div v-show="send">
          <div class="send" @click="getEnd()">提交</div>
          <div class="anstext">请提交答案！</div>
        </div>
        <el-dialog title="测试结果" :visible.sync="dialogVisible" width="30%">
          <div class="ans">正确率：{{ AccuracyText }}</div>
          <span slot="footer" class="dialog-footer">
            <div class="sendgo" @click="gotoBack">返回立体教材详情</div>
          </span>
        </el-dialog>
        <!-- </el-form> -->
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '../../assets/api/axios'
export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        single: '',
        judge: '',
        blanks: '',
        short: '',
        name: '',
        type: [],
      },
      // 综合题答案存储
      comprehensiveAnswers: {},

      single: [],
      multiple: [],
      judge: [],
      blanks: [],
      short: [],
      comprehensive: [], // 综合题数组
      singlesshow: false,
      multipleshow: false,
      judgeshow: false,
      blanksshow: false,
      shortshow: false,
      comprehensiveshow: false, // 综合题显示控制
      send: false,
      type: [],
      answerList: [],
      test: {
        chapterId: '',
        pageNum: 0,
        pageSize: 1,
      },
      Accuracy: false,
      AccuracyText: '',
    }
  },
  created() {
    this.getTestItem()
  },
  methods: {
    gotoBack() {
      this.$router.go(-1)
    },
    async getTestItem(id, v) {
      let fid = this.$route.query.fid
      this.test.chapterId = fid

      // 根据当前题目类型决定pageNum增加量
      let pageIncrement = 1
      if (this.test.pageNum > 0) {
        // 检查当前显示的是否为综合题
        if (this.comprehensiveshow && this.comprehensive.length > 0) {
          // 如果是综合题，根据子题目数量增加pageNum
          const currentComprehensive = this.comprehensive[0]
          if (currentComprehensive && currentComprehensive.examList) {
            pageIncrement = currentComprehensive.examList.length
          }
        }
      }

      this.test.pageNum += pageIncrement

      if (this.test.pageNum > pageIncrement) {
        // 处理综合题答案
        if (Array.isArray(v)) {
          // v 是综合题的答案数组，每个元素包含 fid 和 answer
          v.forEach(answerItem => {
            this.answerList.push(answerItem)
          })
        } else {
          // 普通题目的答案处理
          if (v instanceof Array) {
            var s = v.toString()
            v = s
          }
          this.answerList.push({ fid: id, answer: v })
        }
        console.log('答案', this.answerList)
        this.clear()
      }
      // console.log(this.test.pageNum)
      let res = await api.post(
        '/front/teamaterial/getChapterExamForWX',
        this.test
      )
      console.log(res)
      for (let i = 0; i < res.data.list.length; i++) {
        console.log(res.data.list[i].examType)
        if (res.data.list[i].examType == 0) {
          this.single.push(res.data.list[i])
          this.singlesshow = true
          this.multipleshow = false
          this.judgeshow = false
          this.blanksshow = false
          this.shortshow = false
          console.log(this.single)
          this.sentbut(res.data.isLastPage)
        } else if (res.data.list[i].examType == 1) {
          this.multiple.push(res.data.list[i])
          this.singlesshow = false
          this.multipleshow = true
          this.judgeshow = false
          this.blanksshow = false
          this.shortshow = false
          this.sentbut(res.data.isLastPage)
          console.log(this.multiple)
        } else if (res.data.list[i].examType == 2) {
          this.judge.push(res.data.list[i])
          this.singlesshow = false
          this.multipleshow = false
          this.judgeshow = true
          this.blanksshow = false
          this.shortshow = false
          this.sentbut(res.data.isLastPage)
          console.log(this.judge)
        } else if (res.data.list[i].examType == 3) {
          this.blanks.push(res.data.list[i])
          this.singlesshow = false
          this.multipleshow = false
          this.judgeshow = false
          this.blanksshow = true
          this.shortshow = false
          this.comprehensiveshow = false
          this.sentbut(res.data.isLastPage)
          console.log(this.blanks)
        } else if (res.data.list[i].examType == 6) {
          // 综合题处理
          this.comprehensive.push(res.data.list[i])

          // 初始化综合题子题目的答案
          if (res.data.list[i].examList && res.data.list[i].examList.length > 0) {
            res.data.list[i].examList.forEach(subItem => {
              // 多选题初始化为空数组，其他题型初始化为空字符串
              if (subItem.examType == 1) {
                this.$set(this.comprehensiveAnswers, subItem.fid, [])
              } else {
                this.$set(this.comprehensiveAnswers, subItem.fid, '')
              }
            })
          }

          this.singlesshow = false
          this.multipleshow = false
          this.judgeshow = false
          this.blanksshow = false
          this.shortshow = false
          this.comprehensiveshow = true
          this.sentbut(res.data.isLastPage)
          console.log(this.comprehensive)
        } else {
          this.short.push(res.data.list[i])
          this.singlesshow = false
          this.multipleshow = false
          this.judgeshow = false
          this.blanksshow = false
          this.shortshow = true
          this.comprehensiveshow = false
          this.sentbut(res.data.isLastPage)
          console.log(this.short)
        }
      }
    },
    clear() {
      this.single = []
      this.multiple = []
      this.judge = []
      this.blanks = []
      this.short = []
      this.comprehensive = []
      this.ruleForm.single = ''
      this.ruleForm.judge = ''
      this.ruleForm.blanks = ''
      this.ruleForm.short = ''
      this.ruleForm.type = []
      this.comprehensiveAnswers = {}
    },
    // 获取综合题的答案
    getComprehensiveAnswers(comprehensiveItem) {
      const answers = []

      // 遍历综合题中的每个子题目
      if (comprehensiveItem.examList && comprehensiveItem.examList.length > 0) {
        comprehensiveItem.examList.forEach(subItem => {
          let answer = this.comprehensiveAnswers[subItem.fid]

          // 处理多选题答案格式
          if (subItem.examType == 1 && Array.isArray(answer)) {
            answer = answer.toString()
          }

          // 添加到答案数组
          answers.push({
            fid: subItem.fid,
            answer: answer || ''
          })
        })
      }

      return answers
    },
    sentbut(last) {
      if (last == true) {
        this.send = true
      }
    },
    async getEnd() {
      // 在提交前收集最后一道题的答案
      this.collectCurrentAnswer()

      let res = await api.post('/front/teamaterial/commitChapterExam', {
        chapterId: this.test.chapterId,
        answers: this.answerList,
      })
      this.dialogVisible = true
      this.AccuracyText = res.data.accuracy.toFixed(2)
      // this.send = false
      this.Accuracy = true
    },
    // 收集当前题目的答案
    collectCurrentAnswer() {
      // 单选题
      if (this.singlesshow && this.single.length > 0) {
        const currentItem = this.single[0]
        if (this.ruleForm.single) {
          this.answerList.push({ fid: currentItem.fid, answer: this.ruleForm.single })
        }
      }
      // 多选题
      else if (this.multipleshow && this.multiple.length > 0) {
        const currentItem = this.multiple[0]
        if (this.ruleForm.type && this.ruleForm.type.length > 0) {
          this.answerList.push({ fid: currentItem.fid, answer: this.ruleForm.type.toString() })
        }
      }
      // 判断题
      else if (this.judgeshow && this.judge.length > 0) {
        const currentItem = this.judge[0]
        if (this.ruleForm.judge) {
          this.answerList.push({ fid: currentItem.fid, answer: this.ruleForm.judge })
        }
      }
      // 填空题
      else if (this.blanksshow && this.blanks.length > 0) {
        const currentItem = this.blanks[0]
        if (this.ruleForm.blanks) {
          this.answerList.push({ fid: currentItem.fid, answer: this.ruleForm.blanks })
        }
      }
      // 简答题
      else if (this.shortshow && this.short.length > 0) {
        const currentItem = this.short[0]
        if (this.ruleForm.short) {
          this.answerList.push({ fid: currentItem.fid, answer: this.ruleForm.short })
        }
      }
      // 综合题
      else if (this.comprehensiveshow && this.comprehensive.length > 0) {
        const currentItem = this.comprehensive[0]
        const answers = this.getComprehensiveAnswers(currentItem)
        answers.forEach(answerItem => {
          this.answerList.push(answerItem)
        })
      }

      console.log('最终答案列表', this.answerList)
    },
    // 判断选项是否包含图片URL
    isImageUrl(optionText) {
      if (!optionText) return false
      return optionText.includes('http') && (
        optionText.includes('.jpg') ||
        optionText.includes('.jpeg') ||
        optionText.includes('.png') ||
        optionText.includes('.gif') ||
        optionText.includes('.webp')
      )
    },
    // 从选项文本中提取图片URL
    extractImageUrl(optionText) {
      if (!optionText) return ''
      // 匹配http开头的URL
      const urlMatch = optionText.match(/https?:\/\/[^\s]+/)
      return urlMatch ? urlMatch[0] : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.centest {
  margin: 0 auto;
  width: 940px;
  min-height: 600px;
  background: rgba(255, 255, 255, 1);
  padding: 30px 80px 0 80px;
  .testTit {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 48px;
    border-bottom: 1px solid #d2d2d2ff;
    // padding-bottom: 5px;
  }
  .testTip {
    padding-top: 20px;
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
    line-height: 18px;
  }
  .send {
    width: 100px;
    height: 36px;
    background: rgba(181, 14, 5, 1);
    color: #fff;
    text-align: center;
    line-height: 36px;
    margin: 30px 0 0 0;
  }
  .sendgo {
    width: 160px;
    height: 36px;
    background: rgba(181, 14, 5, 1);
    color: #fff;
    text-align: center;
    line-height: 36px;
    margin: 0 auto;
    cursor: pointer;
  }
}
.Tit {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  padding: 10px 0;
}
.ans {
  font-size: 24px;
  color: rgba(51, 51, 51, 1);
  line-height: 48px;
  text-align: center;
}
.anstext {
  font-size: 24px;
  color: rgba(51, 51, 51, 1);
  line-height: 48px;
  margin: 20px 0 50px;
}
.sub-question {
  margin-bottom: 20px;
}
.title-image {
  margin: 15px 0;
}
.exam-image {
  max-width: 100%;
  max-height: 150px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.option-image {
  max-width: 200px;
  max-height: 150px;
  margin-left: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
</style>
<style lang="scss">
.centest {
  .el-form-item__content {
    margin-left: 0 !important;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
  }
  .el-form-item__label {
    float: none;
    padding-bottom: 10px;
  }
  .el-radio {
    display: block;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background: #666666ff;
    border-color: #666666ff;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: rgba(51, 51, 51, 1);
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .icoLogo {
    margin-left: 8px;
  }
  .icoText {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
  }
  .el-input {
    width: 480px;
  }
  .el-input__inner {
    border-radius: 0;
  }
  .el-textarea {
    width: 480px;
  }
  .el-textarea__inner {
    height: 200px !important;
  }
  .el-checkbox {
    width: 100%;
  }
}
</style>
